import React from 'react';
import modalities from './constants';
import LegendItem from '../LegendItem';
import { Container, ContainerFrame } from './styled';
import WarningMessage from '@/presentation/reusables/WarningMessage';
import Link from '@/presentation/reusables/Link';

const CourseModality = () => (
  <ContainerFrame>
    <Container>
      {modalities.map((modality) => (
        <LegendItem key={modality.id} modality={modality} />
      ))}
    </Container>
    <WarningMessage
      message={
        <>
          Los materiales de los cursos de todas las modalidades estarán
          disponibles en la plataforma{' '}
          <Link
            linkType="external"
            url="https://class.utp.edu.pe"
            linkName="UTP+class."
          />
        </>
      }
    />
  </ContainerFrame>
);

export default CourseModality;
